import React from 'react';
import Helmet from 'react-helmet';

import PhotoSearchCheckoutLayout from '../PhotoSearchCheckout/components/PhotoSearchCheckoutLayout';
import PhotoSearchUpsell from '../PhotoSearchUpsell/PhotoSearchUpsell';

const PhotoSearchUpgradeCheckout = () => {
  return (
    <PhotoSearchCheckoutLayout>
      <Helmet>
        <title>Buy photo searches &ndash; Waldo Photos</title>
      </Helmet>

      <div className="view-sb-checkout">
        <PhotoSearchUpsell theme="white" className="px-0" />
      </div>
    </PhotoSearchCheckoutLayout>
  );
};

export default PhotoSearchUpgradeCheckout;
